import { useMemo } from 'react'
import { usePublicCategories } from './queries/useCategories'

/**
 * Returns a Record<category_name, image_url> map for category fallback images.
 * Used by components that display product images to fall back to a
 * category image when the product has no image_url.
 */
export function useCategoryImageMap(): Record<string, string> {
  const { data } = usePublicCategories()

  return useMemo(() => {
    const map: Record<string, string> = {}
    if (data?.categories) {
      for (const cat of data.categories) {
        if (cat.image_url) {
          map[cat.name] = cat.image_url
        }
      }
    }
    return map
  }, [data])
}
